"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fontSizeTypeMixin = void 0;
var _styledToken = _interopRequireDefault(require("styled-token"));
/** @mixin fontSizeTypeMixin */
/**
 * Get the font size for the given font type.
 *
 * @example
 * import { fontSizeTypeMixin } from '@zillow/constellation';
 *
 * // Add support for "fontType" prop
 * const Component = styled.div`
 *     ${fontSizeTypeMixin}
 * `;
 *
 * // Add a default font type
 * const ComponentWithDefault = styled.div`
 *     ${props => fontSizeTypeMixin({ fontType: 'h1', ...props })}
 * `;
 *
 * <Component fontType="h2">h2 font size</Component>
 * <ComponentWithDefault>h1 font size by default</ComponentWithDefault>
 * <ComponentWithDefault fontType="h3">h3 font size</ComponentWithDefault>
 *
 * @method
 * @param {object} props
 * @param {string} props.fontType - The `fontType` key for the `fontSizes` object.
 * @param {object} props.theme - The styled-components theme object with a `fontSizes` object.
 * @return {Interpolation}
 */
var fontSizeTypeMixin = function fontSizeTypeMixin(props) {
  var fontType = props.fontType;
  if (!fontType) {
    return '';
  }
  return (0, _styledToken.default)({
    fontSizes: 'fontSizes',
    defaultUnit: 'defaultUnit'
  }, function (_ref) {
    var fontSizes = _ref.fontSizes,
      defaultUnit = _ref.defaultUnit;
    var fontSize = fontSizes && fontSizes[fontType];
    if (fontSize && defaultUnit) {
      return "font-size: " + (fontSize + defaultUnit) + ";";
    }
    return '';
  })(props);
};
exports.fontSizeTypeMixin = fontSizeTypeMixin;